export enum KpiVisibilityEnum {
  ThematicMap = 'ThematicMap',
  BI = 'BI',
  Campaign = 'Campaign',
}
